export class DateHelper {
  public static isDate(date: Date): boolean {
    return date instanceof Date && !isNaN(+date);
  }
}
